export const Field = ({ label, testId, ...props }) => (
  <label className="block">
    <span className="text-xs uppercase tracking-[0.2em] text-[var(--muted)]">{label}</span>
    <input data-testid={testId} {...props}
      className="mt-2 w-full bg-transparent border-0 border-b-2 border-[var(--line)] focus:border-[var(--green)] outline-none text-xl md:text-2xl py-2 placeholder:text-[#b8bcb0] transition-colors" />
  </label>
);
